export default function MarketPlaceSuccess() {
  return (
    <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
      <div className='d-flex flex-column flex-column-fluid'>
        <div id='kt_app_content' className='app-content flex-column-fluid'>
          <div id='kt_app_content' className='app-content flex-column-fluid'>
            <div id='kt_app_content_container' className='app-container container-fluid'>
              <h2 className='text-primary'>Thank you for purchasing! 🎉</h2>
              <p className='fs-6 fw-bold text-gray-600 mb-10'>
                Your order has been placed and will be processed as soon as possible.
              </p>

              <div className='d-flex flex-column gap-7 gap-lg-10'>
                <div className='d-flex flex-column flex-xl-row gap-7 gap-lg-10'>
                  <div className='card card-flush py-4 flex-row-fluid'>
                    <div className='card-header'>
                      <div className='card-title'>
                        <h2>Order Details (#14534)</h2>
                      </div>
                    </div>

                    <div className='card-body pt-0'>
                      <div className='table-responsive'>
                        <table className='table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px'>
                          <tbody className='fw-semibold text-gray-600'>
                            <tr>
                              <td className=''>
                                <div className='d-flex align-items-center'>
                                  <i className='ki-outline ki-calendar fs-2 me-2'></i>Date Added
                                </div>
                              </td>
                              <td className='fw-bold text-end'>19/07/2023</td>
                            </tr>
                            <tr>
                              <td className=''>
                                <div className='d-flex align-items-center'>
                                  <i className='ki-outline ki-wallet fs-2 me-2'></i>Payment Method
                                </div>
                              </td>
                              <td className='fw-bold text-end'>Online</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className='card card-flush py-4 flex-row-fluid'>
                    <div className='card-header'>
                      <div className='card-title'>
                        <h2>Customer Details</h2>
                      </div>
                    </div>

                    <div className='card-body pt-0'>
                      <div className='table-responsive'>
                        <table className='table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px'>
                          <tbody className='fw-semibold text-gray-600'>
                            <tr>
                              <td className=''>
                                <div className='d-flex align-items-center'>
                                  <i className='ki-outline ki-profile-circle fs-2 me-2'></i>Customer
                                </div>
                              </td>
                              <td className='fw-bold text-end'>
                                <div className='d-flex align-items-center justify-content-end'>
                                  <div className='symbol symbol-circle symbol-25px overflow-hidden me-3'>
                                    <a href='../../demo31/dist/apps/ecommerce/customers/details.html'>
                                      <div className='symbol-label'>
                                        <img
                                          src='http://localhost:3011/media/avatars/300-3.jpg'
                                          alt='Dan Wilson'
                                          className='w-100'
                                        />
                                      </div>
                                    </a>
                                  </div>

                                  <a
                                    href='../../demo31/dist/apps/ecommerce/customers/details.html'
                                    className='text-gray-600 text-hover-primary'
                                  >
                                    John Doe
                                  </a>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td className=''>
                                <div className='d-flex align-items-center'>
                                  <i className='ki-outline ki-sms fs-2 me-2'></i>Email
                                </div>
                              </td>
                              <td className='fw-bold text-end'>
                                <a
                                  href='../../demo31/dist/apps/user-management/users/view.html'
                                  className='text-gray-600 text-hover-primary'
                                >
                                  doe@extra360.io
                                </a>
                              </td>
                            </tr>
                            <tr>
                              <td className=''>
                                <div className='d-flex align-items-center'>
                                  <i className='ki-outline ki-phone fs-2 me-2'></i>Phone
                                </div>
                              </td>
                              <td className='fw-bold text-end'>+1 545 678 910</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className='card card-flush py-4 flex-row-fluid'>
                    <div className='card-header'>
                      <div className='card-title'>
                        <h2>Documents</h2>
                      </div>
                    </div>

                    <div className='card-body pt-0'>
                      <div className='table-responsive'>
                        <table className='table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px'>
                          <tbody className='fw-semibold text-gray-600'>
                            <tr>
                              <td className=''>
                                <div className='d-flex align-items-center'>
                                  <i className='ki-outline ki-devices fs-2 me-2'></i>Invoice
                                  <span
                                    className='ms-1'
                                    data-bs-toggle='tooltip'
                                    title='View the invoice generated by this order.'
                                  >
                                    <i className='ki-outline ki-information-5 text-gray-500 fs-6'></i>
                                  </span>
                                </div>
                              </td>
                              <td className='fw-bold text-end'>
                                <a
                                  href='../../demo31/dist/apps/invoices/view/invoice-3.html'
                                  className='text-gray-600 text-hover-primary'
                                >
                                  #INV-000414
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='tab-content'>
                  <div
                    className='tab-pane fade show active'
                    id='kt_ecommerce_sales_order_summary'
                    role='tab-panel'
                  >
                    <div className='d-flex flex-column gap-7 gap-lg-10'>
                      <div className='card card-flush py-4 flex-row-fluid overflow-hidden'>
                        <div className='card-header'>
                          <div className='card-title'>
                            <h2>Order #14534</h2>
                          </div>
                        </div>

                        <div className='card-body pt-0'>
                          <div className='table-responsive'>
                            <table className='table align-middle table-row-dashed fs-6 gy-5 mb-0'>
                              <thead>
                                <tr className='text-start fw-bold fs-7 gs-0'>
                                  <th className='min-w-175px'>Product</th>
                                  <th className='min-w-100px text-end'>SKU</th>
                                  <th className='min-w-70px text-end'>Qty</th>
                                  <th className='min-w-100px text-end'>Unit Price</th>
                                  <th className='min-w-100px text-end'>Total</th>
                                </tr>
                              </thead>
                              <tbody className='fw-semibold text-gray-600'>
                                <tr>
                                  <td>
                                    <div className='d-flex align-items-center'>
                                      <div className='ms-5'>
                                        <a
                                          href='../../demo31/dist/apps/ecommerce/catalog/edit-product.html'
                                          className='fw-bold text-gray-600 text-hover-primary'
                                        >
                                          E-Mail Credits
                                        </a>
                                      </div>
                                    </div>
                                  </td>
                                  <td className='text-end'>02601002</td>
                                  <td className='text-end'>1</td>
                                  <td className='text-end'>$16.00</td>
                                  <td className='text-end'>$16.00</td>
                                </tr>
                              </tbody>
                            </table>
                            <div className='d-flex flex-column flex-end w-100 gap-5 mt-5'>
                              <span className='d-flex gap-5'>
                                <p className='fs-5 text-end'>Subtotal</p>
                                <p className='text-end'>$16.00</p>
                              </span>
                              <span className='d-flex gap-5'>
                                <p className='fs-3 text-dark text-end'>Grand Total</p>
                                <p className='text-dark fs-3 fw-bolder text-end'>$16.00</p>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className='tab-pane fade'
                    id='kt_ecommerce_sales_order_history'
                    role='tab-panel'
                  >
                    <div className='d-flex flex-column gap-7 gap-lg-10'>
                      <div className='card card-flush py-4 flex-row-fluid'>
                        <div className='card-header'>
                          <div className='card-title'>
                            <h2>Order History</h2>
                          </div>
                        </div>

                        <div className='card-body pt-0'>
                          <div className='table-responsive'>
                            <table className='table align-middle table-row-dashed fs-6 gy-5 mb-0'>
                              <thead>
                                <tr className='text-start fw-bold fs-7 gs-0'>
                                  <th className='min-w-100px'>Date Added</th>
                                  <th className='min-w-175px'>Comment</th>
                                  <th className='min-w-70px'>Order Status</th>
                                  <th className='min-w-100px'>Customer Notifed</th>
                                </tr>
                              </thead>
                              <tbody className='fw-semibold text-gray-600'>
                                <tr>
                                  <td>09/27/2023</td>
                                  <td>Order completed</td>
                                  <td>
                                    <div className='badge badge-light-success'>Completed</div>
                                  </td>
                                  <td>No</td>
                                </tr>
                                <tr>
                                  <td>18/07/2023</td>
                                  <td>Order received by customer</td>
                                  <td>
                                    <div className='badge badge-light-success'>Delivered</div>
                                  </td>
                                  <td>Yes</td>
                                </tr>
                                <tr>
                                  <td>17/07/2023</td>
                                  <td>Order shipped from warehouse</td>
                                  <td>
                                    <div className='badge badge-light-primary'>Delivering</div>
                                  </td>
                                  <td>Yes</td>
                                </tr>
                                <tr>
                                  <td>16/07/2023</td>
                                  <td>Payment received</td>
                                  <td>
                                    <div className='badge badge-light-primary'>Processing</div>
                                  </td>
                                  <td>No</td>
                                </tr>
                                <tr>
                                  <td>15/07/2023</td>
                                  <td>Pending payment</td>
                                  <td>
                                    <div className='badge badge-light-warning'>Pending</div>
                                  </td>
                                  <td>No</td>
                                </tr>
                                <tr>
                                  <td>14/07/2023</td>
                                  <td>Payment method updated</td>
                                  <td>
                                    <div className='badge badge-light-warning'>Pending</div>
                                  </td>
                                  <td>No</td>
                                </tr>
                                <tr>
                                  <td>13/07/2023</td>
                                  <td>Payment method expired</td>
                                  <td>
                                    <div className='badge badge-light-danger'>Failed</div>
                                  </td>
                                  <td>Yes</td>
                                </tr>
                                <tr>
                                  <td>12/07/2023</td>
                                  <td>Pending payment</td>
                                  <td>
                                    <div className='badge badge-light-warning'>Pending</div>
                                  </td>
                                  <td>No</td>
                                </tr>
                                <tr>
                                  <td>11/07/2023</td>
                                  <td>Order received</td>
                                  <td>
                                    <div className='badge badge-light-warning'>Pending</div>
                                  </td>
                                  <td>Yes</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      <div className='card card-flush py-4 flex-row-fluid'>
                        <div className='card-header'>
                          <div className='card-title'>
                            <h2>Order Data</h2>
                          </div>
                        </div>

                        <div className='card-body pt-0'>
                          <div className='table-responsive'>
                            <table className='table align-middle table-row-bordered mb-0 fs-6 gy-5'>
                              <tbody className='fw-semibold text-gray-600'>
                                <tr>
                                  <td className=''>IP Address</td>
                                  <td className='fw-bold text-end'>172.68.221.26</td>
                                </tr>
                                <tr>
                                  <td className=''>Forwarded IP</td>
                                  <td className='fw-bold text-end'>89.201.163.49</td>
                                </tr>
                                <tr>
                                  <td className=''>User Agent</td>
                                  <td className='fw-bold text-end'>
                                    Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36
                                    (KHTML, like Gecko) Chrome/96.0.4664.110 Safari/537.36
                                  </td>
                                </tr>
                                <tr>
                                  <td className=''>Accept Language</td>
                                  <td className='fw-bold text-end'>en-GB,en-US;q=0.9,en;q=0.8</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='modal fade' id='kt_modal_new_card' aria-hidden='true'>
          <div className='modal-dialog modal-dialog-centered mw-650px'>
            <div className='modal-content'>
              <div className='modal-header'>
                <h2>Confirm Payment</h2>

                <div
                  className='btn btn-sm btn-icon btn-active-color-primary'
                  data-bs-dismiss='modal'
                >
                  <i className='ki-outline ki-cross fs-1'></i>
                </div>
              </div>

              <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
                <form id='kt_modal_new_card_form' className='form' action='#'>
                  <div className='d-flex flex-column mb-7 fv-row'>
                    <label className='d-flex align-items-center fs-6 fw-semibold form-label mb-2'>
                      <span className='required'>Name On Card</span>
                      <span
                        className='ms-1'
                        data-bs-toggle='tooltip'
                        title="Specify a card holder's name"
                      >
                        <i className='ki-outline ki-information-5 text-gray-500 fs-6'></i>
                      </span>
                    </label>

                    <input
                      type='text'
                      className='form-control form-control-solid'
                      placeholder=''
                      name='card_name'
                      value='Max Doe'
                    />
                  </div>

                  <div className='d-flex flex-column mb-7 fv-row'>
                    <label className='required fs-6 fw-semibold form-label mb-2'>Card Number</label>

                    <div className='position-relative'>
                      <input
                        type='text'
                        className='form-control form-control-solid'
                        placeholder='Enter card number'
                        name='card_number'
                        value='4111 1111 1111 1111'
                      />

                      <div className='position-absolute translate-middle-y top-50 end-0 me-5'>
                        <img src='assets/media/svg/card-logos/visa.svg' alt='' className='h-25px' />
                        <img
                          src='assets/media/svg/card-logos/mastercard.svg'
                          alt=''
                          className='h-25px'
                        />
                        <img
                          src='assets/media/svg/card-logos/american-express.svg'
                          alt=''
                          className='h-25px'
                        />
                      </div>
                    </div>
                  </div>

                  <div className='row mb-10'>
                    <div className='col-md-8 fv-row'>
                      <label className='required fs-6 fw-semibold form-label mb-2'>
                        Expiration Date
                      </label>

                      <div className='row fv-row'>
                        <div className='col-6'>
                          <select
                            name='card_expiry_month'
                            className='form-select form-select-solid'
                            data-control='select2'
                            data-hide-search='true'
                            data-placeholder='Month'
                          >
                            <option></option>
                            <option value='1'>1</option>
                            <option value='2'>2</option>
                            <option value='3'>3</option>
                            <option value='4'>4</option>
                            <option value='5'>5</option>
                            <option value='6'>6</option>
                            <option value='7'>7</option>
                            <option value='8'>8</option>
                            <option value='9'>9</option>
                            <option value='10'>10</option>
                            <option value='11'>11</option>
                            <option value='12'>12</option>
                          </select>
                        </div>

                        <div className='col-6'>
                          <select
                            name='card_expiry_year'
                            className='form-select form-select-solid'
                            data-control='select2'
                            data-hide-search='true'
                            data-placeholder='Year'
                          >
                            <option></option>
                            <option value='2023'>2023</option>
                            <option value='2024'>2024</option>
                            <option value='2025'>2025</option>
                            <option value='2026'>2026</option>
                            <option value='2027'>2027</option>
                            <option value='2028'>2028</option>
                            <option value='2029'>2029</option>
                            <option value='2030'>2030</option>
                            <option value='2031'>2031</option>
                            <option value='2032'>2032</option>
                            <option value='2033'>2033</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className='col-md-4 fv-row'>
                      <label className='d-flex align-items-center fs-6 fw-semibold form-label mb-2'>
                        <span className='required'>CVV</span>
                        <span
                          className='ms-1'
                          data-bs-toggle='tooltip'
                          title='Enter a card CVV code'
                        >
                          <i className='ki-outline ki-information-5 text-gray-500 fs-6'></i>
                        </span>
                      </label>

                      <div className='position-relative'>
                        <input
                          type='text'
                          className='form-control form-control-solid'
                          placeholder='CVV'
                          name='card_cvv'
                        />

                        <div className='position-absolute translate-middle-y top-50 end-0 me-3'>
                          <i className='ki-outline ki-credit-cart fs-2hx'></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='text-end pt-5'>
                    <button type='submit' id='kt_modal_new_card_submit' className='btn btn-primary'>
                      <span className='indicator-label'>Submit Payment</span>
                      <span className='indicator-progress'>
                        Please wait...
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id='kt_app_footer' className='app-footer'>
        <div className='app-container container-fluid d-flex flex-column flex-md-row flex-center flex-md-stack py-3'>
          <div className='text-dark order-2 order-md-1'>
            <span className=' fw-semibold me-1'>2023&copy;</span>
            <a
              href='https://extra360.io'
              target='_blank'
              className='text-gray-800 text-hover-primary'
            >
              Extra360
            </a>
          </div>

          <ul className='menu menu-gray-600 menu-hover-primary fw-semibold order-1'>
            <li className='menu-item'>
              <a href='https://www.extra360.io/about' target='_blank' className='menu-link px-2'>
                About
              </a>
            </li>
            <li className='menu-item'>
              <a href='https://devs.keenthemes.com' target='_blank' className='menu-link px-2'>
                Support
              </a>
            </li>
            <li className='menu-item'>
              <a href='https://1.envato.market/EA4JP' target='_blank' className='menu-link px-2'>
                Purchase
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}
